import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { LoadingIndicator } from '@/components/LoadingIndicator/LoadingIndicator';
import { OpenDataCommercial } from '@/components/Logo/OpenDataCommercial';

import { splashScreenStyles as sx } from './SplashScreen.styles';

export const SplashScreen = () => (
	<Box sx={sx.root}>
		<Stack sx={sx.stack}>
			<OpenDataCommercial sx={sx.logo} />
			<LoadingIndicator color='orange' />
		</Stack>
	</Box>
);
